import React from 'react';
import { Sparkles } from 'lucide-react';
import { SECTION_AGENTS } from './sectionAgentConfig';

export default function AgentBanner({ section, onOpen }) {
  const cfg = SECTION_AGENTS[section];
  if (!cfg) return null;
  return (
    <div className={`mb-4 rounded-2xl bg-gradient-to-r ${cfg.color} p-4 shadow-lg flex items-center gap-4`}>
      <div className="w-14 h-14 rounded-2xl bg-white/20 backdrop-blur flex items-center justify-center text-3xl flex-shrink-0 select-none">
        {cfg.emoji}
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-white font-bold text-lg leading-tight">{cfg.name}</div>
        <div className="text-white/85 text-sm">{cfg.tagline}</div>
      </div>
      <button
        onClick={onOpen}
        className="hidden sm:inline-flex items-center gap-2 bg-white/20 hover:bg-white/30 text-white px-3 py-2 rounded-xl font-semibold text-sm backdrop-blur transition">
        <Sparkles size={16} /> Hablar
      </button>
    </div>
  );
}
